export default __webpack_public_path__ + "static/media/Thumb-4.2ba60470.png";